export default __webpack_public_path__ + "2ac45589456ffc4eecc88963d4daeb14.png";